import React, { Suspense, useState, useEffect } from "react";
import { Spin as AntdSpin } from 'antd';
import { useCommonStore } from "../store/useCommonStore";
import postscribe from 'postscribe';
import Config from "../config"


class Spin extends React.Component {
  render() {
    let props = {...this.props};
    delete props.isLoading;
    delete props.pastDelay;
    delete props.error;
    delete props.timedOut;
    delete props.retry;
    delete props.computedMatch;
    delete props.staticContext;
    return (
      <AntdSpin className="loadingSpin" {...props} />
    );
  }
}

const lazyLoad = (Comp) => {
  return (
      <Suspense
          fallback={
            <Spin
                size='large'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
            />
          }
      >
        <Comp />
      </Suspense>
  )
}


const Visualization = (props) => {
  const { user } = useCommonStore();
  const id = user?.OrgId; 
  const [VisualizationComponent, setVisualizationComponent] = useState(null);

  useEffect(() => {
    const loadVisualization = async () => {
      try {
        console.log('id', id);
        async function loadComponent() {
          const module = await import(`@/views/visualization/${id}`);
          const { default: Component } = module;
          setVisualizationComponent(<Component />);
        }
        loadComponent();

        // if (window.T && window.T.Map) {
        //   loadComponent();
        // } else {
        //   postscribe(document.body, '<script src="http://api.tianditu.gov.cn/api?v=4.0&tk=76df2675c1c2e84e7112084a26e59feb"><\/script>', {
        //     done: function() {
        //       console.info('TIANDITU Script loaded and executed');
        //       setTimeout(()=> {
        //           loadComponent();
        //       },0);
        //     }
        //   });
        // }
      } catch (error) {
        if (error.code === 'MODULE_NOT_FOUND') {
          setVisualizationComponent(<div>企业未配置大屏功能</div>);
        } else {
          setVisualizationComponent(<div>{`Failed to load visualization component:${error}`}</div>);
          console.log('大屏出错', error);
        }
      }
    };

    loadVisualization();
  }, [id]);
  //if(VisualizationComponent == null) return (<div></div>);
  return <div>{VisualizationComponent}</div>;
}


// 移交审批（BPMN 待办，限定移交类流程）
const TransferApprovePage = () => {
  const BpmnTodoList = React.lazy(() => import('@/pages/transfer/BpmnTodoList'));
  return (
    <Suspense
      fallback={
        <Spin
          size='large'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />
      }
    >
      <BpmnTodoList processKeys={['record_move_dept', 'record_move_archival']} title="流程版 - 移交审批" />
    </Suspense>
  );
};

export const routers = [
  { path: Config.RoutePrefix + "/login", element: lazyLoad(React.lazy(() => import('@/views/login'))), },
  { path: Config.RoutePrefix + "/visualization", meta: { auth: true }, name: '可视化', element: <Visualization />},
  //{ path: Config.RoutePrefix + "/visualization", name: '可视化', element: lazyLoad(React.lazy(() => import('@/views/visualization')))},
  { path: Config.RoutePrefix + "/blockchain/visualization", name: '可视化', element: lazyLoad(React.lazy(() => import('@/views/visualizationb'))) },
  { path: Config.RoutePrefix + "/notfound", name: '404', element: lazyLoad(React.lazy(() => import('@/views/fzf'))) },
  { path: Config.RoutePrefix + "/download-mongo/:id", name: 'download-from-mongo', element: lazyLoad(React.lazy(() => import('@/component/bizComponent/DownloadFromMongo'))) },
  { path: Config.RoutePrefix + "/view-pdf/:id", name: 'view-pdf', element: lazyLoad(React.lazy(() => import('@/component/bizComponent/ViewPdfFromMongo'))) },
  { path: Config.RoutePrefix + "/view-image/:id", name: 'view-image', element: lazyLoad(React.lazy(() => import('@/component/bizComponent/ViewImageFromMongo'))) },
  { path: Config.RoutePrefix + "/build/v2/:id", name: 'build-v2', element: lazyLoad(React.lazy(() => import('@/views/buildform/buildV2'))) },
  { path: Config.RoutePrefix + "/waterworks-viewer/:id", name: '水厂全屏查看', element: lazyLoad(React.lazy(() => import('@/views/waterworks-viewer'))) },

  {
    path: Config.RoutePrefix+"/",
    element: lazyLoad(React.lazy(() => import('@/views/layout'))),
    meta: { auth: true },
    children: [
      { index: true, element: lazyLoad(React.lazy(() => import('@/views/home'))) },
      { path: Config.RoutePrefix + "/home", alias: '/', element: lazyLoad(React.lazy(() => import('@/views/home'))) },
      { path: Config.RoutePrefix + "/iframe/:id", name: '外部链接', element: lazyLoad(React.lazy(() => import('@/views/iframe'))) },

      { path: Config.RoutePrefix + "/alarm/settings", name: '告警信息配置', element: lazyLoad(React.lazy(() => import('@/views/alarm/settings'))) },
      { path: Config.RoutePrefix + "/settings", name: '设置', element: lazyLoad(React.lazy(() => import('@/views/settings'))) },
      { path: Config.RoutePrefix + "/home/edit", name: '编辑首页', element: lazyLoad(React.lazy(() => import('@/views/home/edit'))) },
      { path: Config.RoutePrefix + "/home/test", name: '测试页面', element: lazyLoad(React.lazy(() => import('@/views/home/test'))) },
      { path: Config.RoutePrefix + "/home/wwdetail/:id/:mode", element: lazyLoad(React.lazy(() => import('@/views/home/wwdetail'))) },
      { path: Config.RoutePrefix + "/home/wwdetail/:id", element: lazyLoad(React.lazy(() => import('@/views/home/wwdetail'))) },
      { path: Config.RoutePrefix + "/home/waterworks/:id", name: '水厂', element: lazyLoad(React.lazy(() => import('@/views/home/waterworks'))) },
      { path: Config.RoutePrefix + "/manager/profile", name: '我的信息', element: lazyLoad(React.lazy(() => import('@/views/profile'))) },

      { path: Config.RoutePrefix + "/alarm/realtime", name: '实时告警', element: lazyLoad(React.lazy(() => import('@/views/realtimealarm'))) },
      { path: Config.RoutePrefix + "/alarm/query", name: '告警查询', element: lazyLoad(React.lazy(() => import('@/views/alarm/query'))) },
      { path: Config.RoutePrefix + "/alarm/set", name: '告警配置', element: lazyLoad(React.lazy(() => import('@/views/alarm-set'))) },

      { path: Config.RoutePrefix + "/monitor/flow", name: '地图监测', element: lazyLoad(React.lazy(() => import('@/views/monitor/flow'))) },
      { path: Config.RoutePrefix + "/listmonitoring", name: '列表监控', element: lazyLoad(React.lazy(() => import('@/views/listmonitoring'))) },
      { path: Config.RoutePrefix + "/listmonitoring/comparison", name: '流量对比分析', element: lazyLoad(React.lazy(() => import('@/pages/FlowComparisonAnalysis'))) },
      { path: Config.RoutePrefix + "/listmonitoring/night-analysis", name: '夜间流量分析', element: lazyLoad(React.lazy(() => import('@/pages/NightFlowAnalysis'))) },
      { path: Config.RoutePrefix + "/monitor/sensor/list", name: '传感器列表', element: lazyLoad(React.lazy(() => import('@/views/sensorlist'))) },
      { path: Config.RoutePrefix + "/monitor/sensor/detail/:id", name: '传感器详情', element: lazyLoad(React.lazy(() => import('@/views/sensordetail'))) },
      { path: Config.RoutePrefix + "/monitor/dma", name: 'DMA分区', element: lazyLoad(React.lazy(() => import('@/views/monitor/dma'))) },
      { path: Config.RoutePrefix + "/report/dma-stat-list", name: 'DMA数据', element: lazyLoad(React.lazy(() => import('@/views/dma/dma-stat-list'))) },
      { path: Config.RoutePrefix + "/monitor/pressure", name: '压力图', element: lazyLoad(React.lazy(() => import('@/views/monitor/pressure'))) },

      { path: Config.RoutePrefix + "/gis/stat-valve-material", name: '按材质统计阀门', element: lazyLoad(React.lazy(()=> import('@/views/gis/stat-valve-material')))},
      { path: Config.RoutePrefix + "/gis/stat-valve-spec", name: '按口径统计阀门', element: lazyLoad(React.lazy(()=> import('@/views/gis/stat-valve-spec')))},
      { path: Config.RoutePrefix + "/gis/stat-pipe-material", name: '按材质统计管长', element: lazyLoad(React.lazy(()=> import('@/views/gis/stat-pipe-material')))},
      { path: Config.RoutePrefix + "/gis/stat-pipe-psize", name: '按管径统计管长', element: lazyLoad(React.lazy(()=> import('@/views/gis/stat-pipe-psize')))},
      { path: Config.RoutePrefix + "/gis/stat-all-device", name: '全设备统计', element: lazyLoad(React.lazy(()=> import('@/views/gis/stat-all-device')))},
      { path: Config.RoutePrefix + "/gis/stat-advanced", name: '高级统计', element: lazyLoad(React.lazy(()=> import('@/views/gis/stat-advanced')))},
      { path: Config.RoutePrefix + "/gis/stat-road", name: '按道路统计', element: lazyLoad(React.lazy(()=> import('@/views/gis/stat-road')))},

      { path: Config.RoutePrefix + "/gis/show-pipe-psize", name: '大口径管线展示', element: lazyLoad(React.lazy(()=> import('@/views/gis/show-pipe-psize')))},
      { path: Config.RoutePrefix + "/gis/show-valve-calibre", name: '大口径阀门展示', element: lazyLoad(React.lazy(()=> import('@/views/gis/show-valve-calibre')))},

      { path: Config.RoutePrefix + "/analysis/valve-impact", name: '阀门影响分析', element: lazyLoad(React.lazy(() => import('@/pages/ValveImpactAnalysis'))) },
      { path: Config.RoutePrefix + "/analysis/valve-cutoff", name: '断流分析', element: lazyLoad(React.lazy(() => import('@/pages/ValveCutoffAnalysis'))) },

      { path: Config.RoutePrefix + "/gis/quick-search", name: '快速查询', element: lazyLoad(React.lazy(()=> import('@/views/gis/quick-search')))},

      { path: Config.RoutePrefix + "/manager/user/list", name: '用户管理', element: lazyLoad(React.lazy(() => import('@/views/manager/userlist'))) },
      { path: Config.RoutePrefix + "/manager/form/list", name: '表单管理', element: lazyLoad(React.lazy(() => import('@/views/manager/formlist'))) },
      { path: Config.RoutePrefix + "/manager/menu/list", name: '菜单管理', element: lazyLoad(React.lazy(() => import('@/views/manager/menulist'))) },
      { path: Config.RoutePrefix + "/manager/role/list", name: '角色管理', element: lazyLoad(React.lazy(() => import('@/views/manager/rolelist'))) },
      { path: Config.RoutePrefix + "/manager/role/popedom", name: '角色权限', element: lazyLoad(React.lazy(() => import('@/views/manager/rolepopedom'))) },
      { path: Config.RoutePrefix + "/manager/role/sensor", name: '角色传感器', element: lazyLoad(React.lazy(() => import('@/views/manager/rolesensor'))) },
      { path: Config.RoutePrefix + "/manager/tenant/list", name: '租户列表', element: lazyLoad(React.lazy(() => import('@/views/manager/tenantlist'))) },

      { path: Config.RoutePrefix + "/report/transient", name: '瞬时量报表', element: lazyLoad(React.lazy(() => import('@/views/report/reportv301'))) },
      { path: Config.RoutePrefix + "/report/accum", name: '累计量报表', element: lazyLoad(React.lazy(() => import('@/views/report/reportv302'))) },
      { path: Config.RoutePrefix + "/report/detail", name: '详情报表', element: lazyLoad(React.lazy(() => import('@/views/report/reportv303'))) },
      { path: Config.RoutePrefix + "/report/flow/month", name: '月统计报表', element: lazyLoad(React.lazy(() => import('@/views/report/reportv305'))) },
      { path: Config.RoutePrefix + "/report/flow", name: '日统计报表', element: lazyLoad(React.lazy(() => import('@/views/report/reportv304'))) },
      { path: Config.RoutePrefix + "/report/water-quality", name: '水质日报表', element: lazyLoad(React.lazy(() => import('@/views/report/reportv306'))) },
      { path: Config.RoutePrefix + "/report/water-quality/month", name: '水质月报表', element: lazyLoad(React.lazy(() => import('@/views/report/reportv307'))) },
      { path: Config.RoutePrefix + "/three/index", name: '3D视角', element: lazyLoad(React.lazy(() => import('@/views/home/threeindex'))) },

      { path: Config.RoutePrefix + "/rust-red/editor", name: 'Rust流程编辑器', element: lazyLoad(React.lazy(() => import('@/pages/rust-editor/RustEditor'))) },
      { path: Config.RoutePrefix + "/kzpipe/monitor", name: 'KZ流程监控', element: lazyLoad(React.lazy(() => import('@/pages/monitor'))) },
      { path: Config.RoutePrefix + "/kzpipe/flow-metrics", name: 'KZ流程拓扑指标', element: lazyLoad(React.lazy(() => import('@/pages/FlowMetrics'))) },
      { path: Config.RoutePrefix + "/bpmn/deploy", name: 'BPMN流程部署', element: lazyLoad(React.lazy(() => import('@/pages/bpmn/deploy'))) },
      { path: Config.RoutePrefix + "/bpmn/definitions", name: '流程定义', element: lazyLoad(React.lazy(() => import('@/pages/bpmn/definitions'))) },
      { path: Config.RoutePrefix + "/bpmn/instances", name: '流程实例', element: lazyLoad(React.lazy(() => import('@/pages/bpmn/instances'))) },
      { path: Config.RoutePrefix + "/bpmn/tasks", name: '任务管理', element: lazyLoad(React.lazy(() => import('@/pages/bpmn/tasks'))) },
      { path: Config.RoutePrefix + "/bpmn/editor/:id/:version", name: '流程编辑器', element: lazyLoad(React.lazy(() => import('@/pages/bpmn/bpmn-editor'))) },
      { path: Config.RoutePrefix + "/transfer/approve", name: '流程版 - 移交审批', element: <TransferApprovePage /> },
      { path: Config.RoutePrefix + "/home/todo", name: '待办事项', element: lazyLoad(React.lazy(() => import('@/pages/home/components/TodoCard'))) },
      { path: "*", name: '404', element: lazyLoad(React.lazy(() => import('@/views/fzf'))) },
    ]
  },

  { path: "*", name: '404', element: lazyLoad(React.lazy(() => import('@/views/fzf'))) },



];
